module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/01be678cc22033db268c55584b4b1145.png";